/**
 * Escapes a URL for interpolation into a CSS `url("...")` token.
 *
 * Deliberately does NOT use `encodeURI`. Stored asset URLs are already percent-encoded
 * (Azure blob names containing spaces or brackets arrive as `%20`, `%28`, `%29`), and
 * `encodeURI` escapes `%` itself — turning `%20` into `%2520` and producing a 404. The only
 * characters that can actually terminate a double-quoted CSS string early are the quote and
 * the backslash, so those are all that need escaping.
 */
export function cssUrlValue(url: string): string {
  return url.replace(/["\\]/g, "\\$&");
}
